function groupKey(metadata) {
  return [
    metadata.vehicle_id ?? '',
    metadata.headlight_type_id,
    metadata.headlight_vehicle_detail_id ?? '',
  ].join(':')
}

function countsTowardsPair(orderVariant) {
  const sharedBulb = orderVariant?.shared_bulb
  if (sharedBulb?.is_spare === true) return false
  return (
    sharedBulb?.duplicate_of === null || sharedBulb?.duplicate_of === undefined
  )
}

export function bulbPairSuggestions(orderVariants = []) {
  const groups = new Map()

  for (const orderVariant of orderVariants || []) {
    const metadata = orderVariant?.metadata || {}
    const required = Number(metadata.headlight_type_bulbs_count)
    const bulbsPerUnit = Number(orderVariant?.bulbs_per_unit)

    if (!metadata.headlight_type_id || !required || !bulbsPerUnit) continue
    if (!countsTowardsPair(orderVariant)) continue

    const key = groupKey(metadata)
    const group = groups.get(key) || {
      lines: [],
      provided: 0,
      required,
      typeName: metadata.headlight_type_name || '',
    }
    group.lines.push(orderVariant)
    group.provided += Number(orderVariant.quantity) * bulbsPerUnit
    groups.set(key, group)
  }

  const suggestions = {}

  for (const group of groups.values()) {
    if (group.provided <= 0 || group.provided >= group.required) continue

    const line = group.lines[0]
    const missingUnits = Math.ceil(
      (group.required - group.provided) / Number(line.bulbs_per_unit)
    )

    suggestions[line.id] = {
      required: group.required,
      quantity: Number(line.quantity) + missingUnits,
      typeName: group.typeName,
    }
  }

  return suggestions
}
